import { useState } from 'react'
import { ChevronDown } from 'lucide-react'
import { cn } from '@/utils/cn'

export function Select({ 
  children, 
  className = '',
  placeholder = 'Select...',
  value = '',
  onValueChange,
  ...props 
}) {
  const [isOpen, setIsOpen] = useState(false)
  const [selectedValue, setSelectedValue] = useState(value)

  const handleSelect = (newValue) => {
    setSelectedValue(newValue)
    onValueChange?.(newValue)
    setIsOpen(false)
  }

  return (
    <div className="relative">
      <button
        type="button"
        className={cn(
          'input flex items-center justify-between cursor-pointer',
          className
        )}
        onClick={() => setIsOpen(!isOpen)}
        {...props}
      >
        <span className={selectedValue ? '' : 'text-muted-foreground'}>
          {selectedValue || placeholder}
        </span>
        <ChevronDown className={cn(
          'h-4 w-4 transition-transform',
          isOpen && 'rotate-180'
        )} />
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 right-0 z-50 mt-1 bg-popover border border-border rounded-xl shadow-lg max-h-60 overflow-auto">
          {children}
        </div>
      )}
    </div>
  )
}

export function SelectItem({ children, value, onSelect }) {
  return (
    <div
      className="px-3 py-2 cursor-pointer hover:bg-accent text-sm"
      onClick={() => onSelect?.(value)}
    >
      {children}
    </div>
  )
}